import { customFetch } from 'utils/http';
import { HTTPResponseError } from 'utils/errors';
import { M8UserFullInfo } from 'services/production/types';
import { getM8AdminURL } from 'services/production/utils/getM8URL';
import { createQueryString } from 'services/production/utils/createQueryString';

type Params = {
  substring: string;
};

export const findActiveUserBySubString = async (
  params: Params
): Promise<M8UserFullInfo[]> => {
  const response = await customFetch(
    getM8AdminURL(`findActiveUserBySubString?${createQueryString(params)}`)
  );

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }

  if (response.status === 200) {
    return response.json();
  }

  return [];
};
